import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

export interface UpdateTrailerParams {
  trailerId: number;
  shipmentNumber: string;
  book: number;
  soft: number;
  misc: number;
  furn: number;
  oli: number;
  vendorID: string;
  dateShipped: string;
  customerKey: number;
}

export const updateTrailerApi = (data: UpdateTrailerParams) => {
  return axiosInstance.request({
    data,
    method: 'put',
    url: `${API.ETRAILER}/updatetrailer`,
  });
};

export type UpdateTrailerResponse = {}[];

export const updateTrailer = async (params: UpdateTrailerParams): Promise<UpdateTrailerResponse> => {
  const response: AxiosResponse<UpdateTrailerResponse> = await updateTrailerApi(params);
  return response.data;
};
